import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useInsurancePlanFromIdQuery } from 'apollo/queries/INSURANCE_PLAN_FROM_ID';
import FilterDropdown from 'components/FilterDropdown';
import { Menu, CheckboxGroup, ListWrap } from './styled';
import { DEFAULT_TITLE, getOptions, getReadableTitle } from './helpers';
var NetworkDropdown = function (_a) {
    var defaultValue = _a.defaultValue, disabled = _a.disabled, planId = _a.planId, onSave = _a.onSave, _b = _a.dataTest, dataTest = _b === void 0 ? 'NetworkDropdown' : _b;
    var _c = useState(defaultValue ? getReadableTitle(planId, defaultValue) : DEFAULT_TITLE), title = _c[0], setTitle = _c[1];
    var _d = useState(defaultValue), value = _d[0], setValue = _d[1];
    var onChange = function (e) {
        setValue(e);
    };
    var onSaveNetwork = function () {
        onSave(value);
    };
    var onResetNetwork = function () {
        setValue([]);
        onSave(undefined);
        setTitle(DEFAULT_TITLE);
    };
    var _e = useInsurancePlanFromIdQuery({
        variables: { id: planId },
        skip: !planId,
        fetchPolicy: 'cache-first'
    }), data = _e.data, loading = _e.loading;
    useEffect(function () {
        // Reset the filter if value is reset from outside
        if (!defaultValue)
            onResetNetwork();
        // eslint-disable-next-line
    }, [defaultValue]);
    useEffect(function () {
        // Rebuild the title when plan data becomes available
        if (data) {
            setTitle(getReadableTitle(planId, value));
        }
        // eslint-disable-next-line
    }, [loading, value]);
    var options = getOptions(data === null || data === void 0 ? void 0 : data.insurance_plan);
    return (_jsx(FilterDropdown, { title: title, content: _jsx(Menu, { selectable: false, children: _jsx(ListWrap, { children: _jsx(CheckboxGroup, { options: options, onChange: onChange, value: value }) }) }), disabled: disabled, loading: loading, hasDefaultValue: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) > 0, onSave: onSaveNetwork, onReset: onResetNetwork, dataTest: dataTest }));
};
export default NetworkDropdown;
